import React, { useState, useEffect } from "react";
import { SelectChangeEvent, useMediaQuery } from "@mui/material";
import { postIgnoreCartCheck } from "../../api/SidebarApi";
import { woodForWood, wood } from "../Wood/defaults";
import { cartCheckUpdate } from "../../api/SidebarApi";
import { useQueryClient } from "react-query";
import { LineItem } from "../../util/checkCart";
import { useTheme } from "@mui/material";
import { ChoicesObj } from "./CartCheckModal";

const headerKeys = [
  "glass",
  "handle",
  "handleHeight",
  "spacer",
  "wood",
  "screenColor",
  "breatherTubes",
  "kerf",
  "cladColor",
];

function useCartCheckModalSelector(
  cartCheck: LineItem[],
  quoteId: string,
  userId: string,
  routeToOrderSummary: (check: boolean, checked: boolean) => void
) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const queryClient = useQueryClient();

  const [choices, setChoices] = useState<ChoicesObj>({});

  const [checked, setChecked] = useState(false);

  const [loading, setLoading] = useState(false);

  const [disable, setDisable] = useState(true);

  const [error, setError] = useState(false);

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) =>
    setChecked(e.target.checked);

  const keys = Object.keys(cartCheck[0]).sort();

  const headers = keys.filter((key) => headerKeys.includes(key));

  const handleChange = (
    event:
      | SelectChangeEvent<string>
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    id: string | undefined,
    material?: string
  ) => {
    const { name, value } = event.target;
    setDisable(false);

    let obj = JSON.parse(JSON.stringify(choices));
    if (name === "wood") {
      if (material?.includes("Clad")) {
        const woodLabel = wood.find((w) => w.abbrev === value)?.label;
        obj[id as keyof ChoicesObj]["woodSpecies"] = woodLabel;
      } else {
        const woodLabel = woodForWood.find((w) => w.abbrev === value)?.label;
        obj[id as keyof ChoicesObj]["woodSpecies"] = woodLabel;
      }
    }
    obj[id as keyof ChoicesObj][name] = value;
    setChoices(obj);
  };

  const onSubmit = async () => {
    setLoading(true);

    const res = await cartCheckUpdate(quoteId, choices, userId);

    if (res.data === "Success") {
      if (checked) {
        await postIgnoreCartCheck(quoteId);
      }
      setError(false);
      queryClient.invalidateQueries("QuoteCart");
      routeToOrderSummary(true, checked);
      setLoading(false);
      return;
    }

    setError(true);
    setLoading(false);
  };

  useEffect(() => {
    const obj: ChoicesObj = {};

    cartCheck.forEach((item) => {
      obj[`${item.id}`] = {
        ...item,
      };
    });
    setChoices(obj);
  }, []);

  return {
    onSubmit,
    handleChange,
    headers,
    handleCheck,
    error,
    loading,
    disable,
    fullScreen,
    choices,
    checked,
  };
}

export default useCartCheckModalSelector;
